// SecurityTab — thin wrapper that mounts the Security page inside the
// Settings tabs UI so users can find 2FA at /settings?tab=security as well
// as /settings/security.
import React from 'react';
import Security from '../Security.jsx';

export default function SecurityTab() {
  return <Security />;
}
